/**
 * 彩易分析 - 系统常量 - 用户自定义
 * https://menger.me
 * @大梦
 */

'use strict';

export default {
    /**
     * @微信支付的appID
     */
    // WECHAT_APPID: 'wxe9437a33c181f117',
    // 易行东方
    // WECHAT_APPID: 'wx1707fa10fb8802f2',
    // 深圳金钥匙
    WECHAT_APPID: 'wx0c92b7c48b9d2269',

    /**
     * @阿里支付Scheme
     */
    ALIPAY_SCHME: 'alipay2021001158622510',

    /**
     * @支付方式
     */
    // 余额支付
    PAYMENT_BALANCE: 'payment_balance',
    // 微信支付
    PAYMENT_WECHAT: 'payment_wechat',
    // 支付宝支付
    PAYMENT_ALIPAY: 'payment_alipay',

    /**
     * @显示弹窗
     */
    // 登录弹窗
    SHOWLOGINDIALOG: 'showLoginDialog',
    // 分享弹窗
    SHOWSHAREPOPUP: 'showSharePopup',
    // 绑定手机号弹窗
    SHOWBINDMOBILEPOPUP: 'showBindMobilePopup',

    /**
     * @页面类型
     */
    // 普通页面
    PAGE_NORMAL: 'page_normal',

    // 广告页默认展示时间(秒)
    DEFAULT_AD_SHOW_TIME: 5,

    // 取消
    CANCEL: 'cancel',

    // 增加
    INCREASE: 'increase',
    // 减少
    DECREASE: 'decrease',

    // 正序
    SORT_ASC: 'asc',
    // 倒序
    SORT_DESC: 'desc',

    /**
     * @消息类型
     */
    // 系统消息
    MSG_SYS: 'system',
    // 我的消息
    MSG_MY: 'my',

    /**
     * @用户角色
     */
    // 学员
    USER_STUDENT: 'student',
    // 新学员
    USER_STU_NEW: 'new',
    // 老学员
    USER_STU_OLD: 'old',
    // 代理商
    USER_AGENT: 'agent',
    // 传承师
    USER_MASTER: 'master',
    // 讲师
    USER_TEACHER: 'teacher',
    // 课程
    USER_CLASS: 'class',
    // 义工
    USER_WORKER: 'worker',
    // 义工
    USER_VOLUNTEER: 'volunteer',
    // 义工 - 桌长
    WORKER_LEADER: '0',
    // 义工 - 外围
    WORKER_GROUP: '1',

    /**
     * @审核状态
     */
    // 通过
    RESOLVE: '1',
    // 拒绝
    REJECT: '-1',

    /**
     * @沙龙列表状态
     */
    // 暂存草稿
    SALON_TITLE0: '暂存',
    SALON_STATUS0: 0,
    // 审核中
    SALON_TITLE1: '审核中',
    SALON_STATUS1: 1,
    // 进行中
    SALON_TITLE2: '进行中',
    SALON_STATUS2: 2,
    // 已结束
    SALON_TITLE3: '已结束',
    SALON_STATUS3: 3,
    // 被拒绝
    SALON_TITLE4: '已拒绝',
    SALON_STATUS4: 4,

    /**
     * @门票状态
     */
    TICKET_TITLE0: '未使用',
    TICKET_STATUS0: '0',
    TICKET_TITLE1: '已发放',
    TICKET_STATUS1: '1',
    TICKET_TITLE2: '已使用',
    TICKET_STATUS2: '2',
    TICKET_USE_TITLE1: '学员未报名',
    TICKET_USE_STATUS1: '0',
    TICKET_USE_TITLE2: '学员已报名',
    TICKET_USE_STATUS2: '1',

    /**
     * @成交方式
     */
    // 线上
    DEAL_ONLINE_TITLE: '线上报名',
    DEAL_ONLINE_VALUE: 'up',
    // 线下
    DEAL_OFFLINE_TITLE: '线下报名',
    DEAL_OFFLINE_VALUE: 'down',

    /**
     * @签到状态
     */
    // 已签到
    SIGN_STATUS_TRUE: '1',
    // 未签到
    SIGN_STATUS_FALSE: '0',

    /**
     * @账户类型
     */
    // 商城收入
    ACCOUNT_SHOP: 'shop',
    // 课程收入
    ACCOUNT_CLASS: 'subject',

    /**
     * @提现方式
     */
    // 公司商户(商城提现)
    WITHDRAW_PUBLIC: 'public',
    // 个体商户有公户(商城提现)
    WITHDRAW_INDIVIDUAL_PUBLIC: 'individual_public',
    // 个体商户无公户(商城提现)
    WITHDRAW_NO_PUBLIC: 'no_public',
    // 微信(课程提现)
    WITHDRAW_WECHAT: 'wechat',
    // 支付宝(课程提现)
    WITHDRAW_ALIPAY: 'alipay',
    // 银行卡(课程提现)
    WITHDRAW_BANK: 'bank',

    /**
     * @导航类型
     */
    // 缴费记录
    RECORD_PAYMENT: 'record_payment',
    // 上课记录
    RECORD_CLASS: 'record_class',
    // 商城消费记录
    RECORD_SHOP: 'record_shop',

};